import $i18n from '@/i18n';
import ColorTags from '@/components/ColorTags';
import { Icon } from '@b-design/fusion';
import { formatTime } from '@/utils';
import { history } from 'ice';
import { getApprovalsResult } from '@/utils/status';
import React from 'react';

const typeEmun = {
  VERSION_PUBLISH_APPROVE: $i18n.get({
    id: 'aopf.pages.approvals.typeC',
    dm: '版本发布',
  }),
  SPACE_SETTLEMENT_APPROVE: $i18n.get({
    id: 'aopf.pages.approvals.typeB',
    dm: '空间入驻',
  }),
  JSAPI_APP_APPROVE: $i18n.get({
    id: 'aopf.pages.approvals.type.jsapiAuth',
    dm: 'JSAPI 授权申请',
  }),
  APP_URL_APPROVE: $i18n.get({
    id: 'aopf.component.myRequest.const.MiniProgramJumpUrlApplication',
    dm: '小程序跳转URL申请',
  }),
};

const status = {
  active: { color: 'var(--superapp-primary-1)', cursor: 'pointer' },
  disabled: { color: 'rgba(212,214,225,1)' },
};

export const renderActionItem = ({ icon, content, active }) => {
  return (
    <div style={active ? status.active : status.disabled}>
      <Icon type={icon} size={'xs'} style={{ marginRight: '12px' }} />
      {content}
    </div>
  );
};

const renderTitle = (spaceId, approveId, title) => {
  return (
    <a
      style={{ textDecoration: 'underline', color: '#585F7E' }}
      onClick={() => {
        history?.push(
          `/approvals/detail?spaceId=${spaceId || ''}&approveId=${approveId}&defaultActiveKey=MyRequest`,
        );
      }}
    >
      {title}
    </a>
  );
};
export const getColumns = (spaceId) => [
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsTitle', dm: '标题' }),
    cell: (value, index, record) => {
      switch (record.type) {
        case 'APP_URL_APPROVE': {
          const urlList = record?.approveInfo?.urls?.split(',');
          const url = urlList[0];
          const appName = record?.extInfo?.description?.name || '';
          let approveTitle = '';
          if (urlList?.length > 1) {
            approveTitle = $i18n.get(
              {
                id: 'aopf.approvals.component.const.applay.multiple',
                dm: '（{appName}）跳转（{url}）等多条申请',
              },
              { appName, url },
            );
          } else {
            approveTitle = $i18n.get(
              {
                id: 'aopf.approvals.component.const.applay.single',
                dm: '（{appName}）跳转（{url}）的申请',
              },
              { appName, url },
            );
          }
          return renderTitle(spaceId, record.approveId, approveTitle);
        }
        case 'JSAPI_APP_APPROVE': {
          const appName = record?.extInfo?.channel?.channelName;
          const jsapiNames = record?.extInfo?.applyJsapiList;
          let approveTitle = '';

          if (jsapiNames?.length === 1) {
            approveTitle = $i18n.get(
              {
                id: 'aopf.pages.approvals.jsapi.single',
                dm: '（{appName}）的（{jsapiName}）授权申请',
              },
              { appName: jsapiNames[0]?.channelName, jsapiName: jsapiNames[0]?.jsapiName },
            );
          } else if (jsapiNames?.length > 1) {
            approveTitle = $i18n.get(
              {
                id: 'aopf.pages.approvals.jsapi.multiple',
                dm: '（{appName}）的（{jsapiName}）等多条授权申请',
              },
              { appName: jsapiNames[0]?.channelName, jsapiName: jsapiNames[0]?.jsapiName },
            );
          }
          return renderTitle(spaceId, record.approveId, approveTitle);
        }
        case 'SPACE_SETTLEMENT_APPROVE':
          return renderTitle(
            spaceId,
            record.approveId,
            `${record?.extInfo?.space?.name} ${$i18n.get({
              id: 'aopf.pages.approvals.onboarding',
              dm: '入驻',
            })}`,
          );
        case 'VERSION_PUBLISH_APPROVE':
          return renderTitle(
            spaceId,
            record.approveId,
            `${record?.extInfo?.description?.name} ${$i18n.get({
              id: 'aopf.pages.approvals.version',
              dm: '版本',
            })} ${record?.extInfo?.description?.version} ${$i18n.get({
              id: 'aopf.pages.approvals.Releasing',
              dm: '发布',
            })}`,
          );

        default:
          return null;
      }
    },

    width: 160,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsType', dm: '类型' }),
    dataIndex: 'type',
    cell: (value) => typeEmun?.[value],
    width: 140,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsSumbit', dm: '提交人' }),
    dataIndex: 'createName',
    width: 120,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsCreatedOn', dm: '创建时间' }),
    dataIndex: 'gmtCreate',
    cell: (value) => formatTime(value),
    width: 160,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsFinishTime', dm: '结束时间' }),
    dataIndex: 'gmtModified',
    cell: (value) => formatTime(value),
    width: 160,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsApprovalStatus', dm: '批准状态' }),
    dataIndex: 'approveAction',
    width: 130,
    cell: (value) =>
      value == null ? (
        <ColorTags {...getApprovalsResult('APPROVE')} />
      ) : (
        <ColorTags {...getApprovalsResult(value)} />
      ),
  },
];
